var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "app flex-row align-items-center" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          { staticClass: "col-md-6 col-lg-5" },
          [
            _vm.setup2fa
              ? _c(
                  "b-modal",
                  {
                    attrs: {
                      title: "Two-Factor Authentication Required",
                      size: "lg",
                      "hide-footer": "",
                      "no-close-on-backdrop": "",
                      "no-close-on-esc": "",
                      centered: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "modal-header",
                          fn: function ({ titleClass }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center w-100",
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa fa-shield text-primary mr-2 fa-lg",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "h5",
                                    { staticClass: "mb-0", class: titleClass },
                                    [
                                      _vm._v(
                                        "\n                Two-Factor Authentication Setup\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2978719273
                    ),
                    model: {
                      value: _vm.setup2fa,
                      callback: function ($$v) {
                        _vm.setup2fa = $$v
                      },
                      expression: "setup2fa",
                    },
                  },
                  [
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-center mb-4" },
                      [
                        _c(
                          "b-alert",
                          {
                            staticClass: "mb-3",
                            attrs: { show: "", variant: "info" },
                          },
                          [
                            _c("i", { staticClass: "fa fa-info-circle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Security Required:")]),
                            _vm._v(
                              " All users must complete 2FA setup to access the system.\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return _vm.validateOTP.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "setup-steps" }, [
                          _c("div", { staticClass: "step mb-4" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-start" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3",
                                    staticStyle: {
                                      "min-width": "32px",
                                      height: "32px",
                                      "font-weight": "bold",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    1\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "flex-grow-1" }, [
                                  _c("h6", { staticClass: "mb-2" }, [
                                    _vm._v(
                                      "\n                      Install an Authenticator App\n                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "mb-3 text-muted" }, [
                                    _vm._v(
                                      "\n                      Download one of these apps on your mobile device:\n                    "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "app-links" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2 mb-2",
                                          attrs: {
                                            variant: "outline-success",
                                            size: "sm",
                                            href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-android mr-1",
                                          }),
                                          _vm._v(
                                            " Android\n                      "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2 mb-2",
                                          attrs: {
                                            variant: "outline-dark",
                                            size: "sm",
                                            href: "https://itunes.apple.com/gb/app/google-authenticator/id388497605",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-apple mr-1",
                                          }),
                                          _vm._v(
                                            " iOS\n                      "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mr-2 mb-2",
                                          attrs: {
                                            variant: "outline-info",
                                            size: "sm",
                                            href: "https://www.microsoft.com/en-gb/store/p/microsoft-authenticator/9nblgggzmcj6",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-windows mr-1",
                                          }),
                                          _vm._v(
                                            " Windows\n                      "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "mb-2",
                                          attrs: {
                                            variant: "outline-primary",
                                            size: "sm",
                                            href: "https://support.1password.com/one-time-passwords/?linux#save-your-one-time-password-code",
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fa fa-key mr-1",
                                          }),
                                          _vm._v(
                                            " 1Password\n                      "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "step mb-4" }, [
                            _c(
                              "div",
                              { staticClass: "d-flex align-items-start" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "step-number bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-3",
                                    staticStyle: {
                                      "min-width": "32px",
                                      height: "32px",
                                      "font-weight": "bold",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    2\n                  "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "flex-grow-1 text-center" },
                                  [
                                    _c("h6", { staticClass: "mb-3" }, [
                                      _vm._v(
                                        "\n                      Scan this QR Code\n                    "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "qr-code-container d-flex justify-content-center mb-1",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "p-3 bg-white border rounded shadow-sm",
                                          },
                                          [
                                            _c("qriously", {
                                              attrs: {
                                                value: _vm.otpauth,
                                                size: 200,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("small", { staticClass: "text-muted" }, [
                                      _vm._v(_vm._s(_vm.secretKey)),
                                    ]),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex justify-content-between mt-4 pt-3 border-top",
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "outline-secondary" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push("/login")
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-arrow-left mr-1",
                                }),
                                _vm._v(" Back to Login\n              "),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              { attrs: { type: "submit", variant: "primary" } },
                              [
                                _vm._v("\n                Continue "),
                                _c("i", {
                                  staticClass: "fa fa-arrow-right ml-1",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("footer", { staticClass: "login-footer" }, [
      _c("img", {
        staticClass: "labs-logo login center-block",
        attrs: { src: "static/img/labs_logo.svg", alt: "labs-img" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }